import { docReady } from '../utilities';

docReady(function() {
    var contentTables = document.getElementsByTagName('table');
    for (var i = 0; i < contentTables.length; i++) {
        wrap(contentTables[i], document.createElement('div'));
    }
});

function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    wrapper.classList.add('responsive-table');
}
